import type { AppNavManifestGroup } from "@tc-superpods/app-contract";
import type { NavEntry } from "./types";

export function navManifestGroupsToEntries(groups: AppNavManifestGroup[] | undefined): NavEntry[] {
  return (groups ?? []).flatMap((group) =>
    group.items.map((item): NavEntry => ({
      id: item.id,
      label: item.label,
      route: item.route,
      icon: item.icon,
      group: group.id,
      groupLabel: group.label,
      groupIcon: group.icon
    }))
  );
}

// Live bus-registered items (nav:register) for the currently-mounted app are
// upserted onto its static navGroups entries — not swapped in exclusively — so
// an app that never dynamically registers anything still shows its static
// items once mounted, and one that does (to demonstrate the dynamic path)
// shows both instead of losing its static entries the moment it's active.
export function mergeNavEntries(staticEntries: NavEntry[], liveEntries: NavEntry[]): NavEntry[] {
  return liveEntries.reduce((entries, liveEntry) => {
    const index = entries.findIndex((entry) => entry.id === liveEntry.id);
    if (index === -1) {
      return [...entries, liveEntry];
    }
    return entries.map((entry, entryIndex) => (entryIndex === index ? liveEntry : entry));
  }, staticEntries);
}
